import { memberGQLFields } from '../network/index.js';
const BASIC_LEADERBOARD_FIELDS = {};
const ALL_LEADERBOARD_FIELDS = {
    member: 'basic',
    score: 'basic',
};
const DEFAULT_LEADERBOARD_FIELDS = {
    member: 'default',
    score: 'basic',
};
export const leaderboardGQLFields = (fields) => {
    if (fields === 'basic')
        fields = BASIC_LEADERBOARD_FIELDS;
    if (fields === 'all')
        fields = ALL_LEADERBOARD_FIELDS;
    if (fields === 'default')
        fields = DEFAULT_LEADERBOARD_FIELDS;
    return `
    memberId
    ${fields.score ? 'score' : ''}
    ${fields.member
        ? `
      member {
        ${memberGQLFields(fields.member)}
      }
    `
        : ``}
  `;
};
